var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "206.8px",
    height: "187.399px",
    viewBox: "21.3 31.7 206.8 187.399",
    enableBackground: "new 21.3 31.7 206.8 187.399",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M21.3,108.6v108.9v1.6H64V108.6H21.3z M35.2,123.6h15v15h-15V123.6z M35.2,153.6h15v15h-15V153.6z  M50.2,198.5h-15v-15h15V198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M185.4,108.6v108.9v1.6H228.1V108.6H185.4z M214.2,198.5h-15v-15h15V198.5z M214.2,168.5h-15v-15h15V168.5z  M214.2,138.6h-15v-15h15V138.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M152.1,73.2V31.7H97.4v41.5H73.7V219h39v-29.9H137.6V219h38V73.2H152.1z M109.5,54.2h11.9V42.3h7.5v11.9 H140.8v7.5H129v11.9h-7.5V61.7h-11.9v-7.5H109.5z M160.9,173.5H88.5v-15h72.4V173.5z M160.9,143.6H88.5v-15h72.4V143.6z  M160.9,113.6H88.5v-15h72.4V113.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.2ff80a7d45d16394d84d667383d29188.svg";
export { ForwardRef as ReactComponent };